<template>
  <div class="hdcgthsele flex_start">
    <div class="label">{{label}}</div>
    <div class="taglist flex_start wrap">
      <div
        class="tagitem"
        v-for="(item, index) in list"
        :key="index"
        :class="{ tagact: activindex == index }"
        @click="chageactiv(index)"
      >
        {{item.cat_name}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label:{
      type:String,
      default:'一级分类'
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    activindex: 0,
  }),
  methods: {
    chageactiv(index) {
      this.activindex = index;
      this.$emit("change", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.hdcgthsele {
  width: 100%;
  align-items: flex-start;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  .label {
    padding: 6px 10px;
    width: 110px;
    font-size: 14px;
    color: #999999;
  }
  .taglist {
    width: 1000px;
    font-size: 14px;
    color: #333;
    .tagitem {
      padding: 6px 10px;
      margin-right: 14px;
      margin-bottom: 10px;
      border-radius: 20px;
      cursor: pointer;
      &.tagact {
        color: #ffffff;
        background: #0465ea;
      }
    }
  }
}
</style>